module.exports = __webpack_public_path__ + "img/blocked-icon.babc6bc6.svg";